<template>
  <div>
    <div class="part part1">
        <div class="title">患者信息</div>
        <el-form :inline="true" label-width="140px" label-position="right" :model="qualityControlVo"
                 class="form">
          <el-form-item label-width="auto" label="姓名">
            <el-input size="small" readonly v-model="qualityControlVo.commonPatName" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="性别">
            <el-input  size="small" readonly v-model="qualityControlVo.changeCommonPatSex" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="年龄">
            <el-input  size="small" readonly v-model="qualityControlVo.commonPatAge" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="生日">
            <el-input  size="small" readonly v-model="qualityControlVo.commonPatBirth" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="手机号">
            <el-input  size="small" readonly v-model="qualityControlVo.commonPatPhone" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="身份证号">
            <el-input  size="small" readonly v-model="qualityControlVo.commonPatIdcard" placeholder="" />
          </el-form-item>
        </el-form>

        <div class="title">挂号信息</div>
        <el-form :inline="true" label-width="140px" label-position="right" :model="qualityControlVo"
                 class="form">
          <el-form-item label-width="auto" label="挂号ID">
            <el-input size="small" readonly v-model="qualityControlVo.bookId" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="挂号订单号">
            <el-input  size="small" readonly v-model="qualityControlVo.bookOrderNumber" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="就诊日期">
            <el-input  size="small" readonly v-model="qualityControlVo.bookTime" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="病历号">
            <el-input  size="small" readonly v-model="qualityControlVo.visitNumber" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="所属医院">
            <el-input  size="small" readonly v-model="qualityControlVo.hosName" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="所属科室">
            <el-input  size="small" readonly v-model="qualityControlVo.deptName" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="医生姓名">
            <el-input  size="small" readonly v-model="qualityControlVo.docName" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="医生手机号">
            <el-input  size="small" readonly v-model="qualityControlVo.docMobile" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="医生身份证">
            <el-input  size="small" readonly v-model="qualityControlVo.docIdcard" placeholder="" />
          </el-form-item>
        </el-form>

        <div class="title">病历质控结果</div>
        <el-form :inline="true" label-width="140px" label-position="right" :model="qualityControlVo"
                 class="form">
          <el-form-item label-width="auto" label="处理结果">
            <el-input size="small" readonly v-model="qualityControlVo.statusTxt" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="是否通报">
            <el-input  size="small" readonly v-model="qualityControlVo.handleResultTxt" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="处方得分">
            <el-input  size="small" readonly v-model="qualityControlVo.finalScore" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="医生是否已阅">
            <el-input  size="small" readonly v-model="qualityControlVo.docIsReadTxt" placeholder="" />
          </el-form-item>
          <el-form-item label-width="auto" label="问题汇总">
            <el-input
                size="small" readonly
                type="textarea"
                autosize
                placeholder=""
                v-model="qualityControlVo.questionCollect">
            </el-input>
          </el-form-item>
        </el-form>
    </div>
    <div class="part part2">
      <div>
        <div class="title">病历信息</div>
          <div class="pat-into">
            <p>就诊人编号：{{qualityControlVo.commonPatId}}   患者姓名：{{qualityControlVo.commonPatName}}   患者性别：{{qualityControlVo.changeCommonPatSex}}
              就诊人证件号：{{qualityControlVo.commonPatIdcard}}   年龄：{{qualityControlVo.commonPatAge}}   手机号：{{qualityControlVo.commonPatPhone}}</p>
            <p>主诉：{{qualityControlVo.actionInChief}}</p>
            <p>既往史：{{qualityControlVo.previousHistory}}</p>
            <p>家族史：{{qualityControlVo.familyHistory}}</p>
            <p>过敏史： {{qualityControlVo.drugAllergyHistory}}</p>
            <p>现病史：{{qualityControlVo.historyPresentIllness}}</p>
            <p>诊断：{{qualityControlVo.diagnose}}</p>
            <p>专科/辅助检查：{{qualityControlVo.auxiliaryExamination}}</p>
            <p>就诊号：{{qualityControlVo.visitNumber}}</p>
            <p>医生处理：{{qualityControlVo.treatmentOptions}}</p>
            <p>病历pdf地址： <a :href="qualityControlVo.signPdfUrl" target="_blank">查看pdf病历文件</a></p>
          </div>
      </div>
    </div>
    <div class="part part3">
      <div class="title">处方质控</div>
      <div class="the-table">
        <el-table
            :data="qualityControlDetailList"
            border
            style="width: 100%">
          <el-table-column
              prop="projectName"
              label="考评项目"
              width="120">
          </el-table-column>
          <el-table-column
              prop="totalScore"
              label="分值"
              width="60">
          </el-table-column>
          <el-table-column
              prop="evaluationStandard"
              label="考评标准">
          </el-table-column>
          <el-table-column
              prop="deductionScore"
              label="扣分"
              width="60">
          </el-table-column>
          <el-table-column
              prop="deductionScoreReason"
              label="扣分原因"
              width="120">
          </el-table-column>
          <el-table-column
              prop="surplusScore"
              label="项目得分"
              width="120">
          </el-table-column>
          <el-table-column
              prop="createTime"
              label="创建时间"
              width="120">
          </el-table-column>
        </el-table>
      </div>
      <div class="title score">最终得分({{qualityControlVo.finalScore}})</div>
    </div>
  </div>
</template>
<script lang="js">
import axiosUtil from "@/js/utils/AxiosUtils";
import dayjs from "dayjs"
export default {
  data() {
    return {
      formLabel: {},
      rowId: '',
      qualityControlVo: {},
      qualityControlDetailList: []
    }
  },
  mounted() {
    console.log(`====this.$route.row_id=========>`,this.$route.query.rowId)
    this.rowId=this.$route.query.rowId
    this.getDetail()
  },
  methods: {
    getDetail() {
      let _this = this
      let options = {
        token: localStorage.getItem("token"),
        qualityControlId: this.rowId,
        service: "smarthos.user.book.case.history.quality.control.detail.info",
      };
      axiosUtil(options, function (res) {
        let objj = res.obj.qualityControlVo
        objj.statusTxt = objj.status == 1 ? '已处理' : '未处理'
        objj.handleResultTxt = objj.handleResult == 1 ? '通报' : '合格'
        objj.docIsReadTxt = objj.docIsRead == 1 ? '已阅' : '未阅'
        _this.qualityControlVo = objj
        let list = res.obj.qualityControlDetailList
        if (list && list.length > 0) {
          list.map(item => {
            item.createTime = dayjs(item.createTime).format('YYYY-MM-DD')
            return item
          })
        }
        _this.qualityControlDetailList = list
      });
    }
  }
}
</script>
<style lang="scss">
.part{
  padding: 15px;
  margin-bottom: 15px;
  color: #606266;
  line-height: 25px;
}
.title{
  padding: 0 0 15px 0;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.score{
  margin-top: 15px;
  text-align: right;
  font-size: 14px;
}
.form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.el-form--inline .el-form-item {
  flex: 1 0 40%;
  align-items: center;
}

//第一行按钮独占一行
.form-item-full {
  flex: 100% !important;
}
.the-table{
  font-size: 14px;
  tr{
    border-bottom: 1px solid #f2f2f2;
    th,td{
      padding: 10px 5px;
      border-left: 1px solid #f2f2f2;
      border-bottom: 1px solid #f2f2f2;
    }
  }
}

.pat-into{
  >p{
    padding: 5px 0;
    font-size: 14px;
  }
  a, a:hover{
    color: #00b2b1;
  }
}
</style>